import { ModalHandler } from '@app-velocity/ui';

import { AuthModalContent } from './components/AuthModalContent';

export const AuthModal = () => {
  return (
    <ModalHandler channel="users" id="auth">
      <AuthModalContent />
    </ModalHandler>
  );
};
